import type { TestContext } from 'yup';

export function changeRuleNameValidation(value: string, context: TestContext<{ initialRuleName: string }>) {
  return context.options.context?.initialRuleName !== value;
}
